import type { AppRouteModule } from '/@/router/types';

import { LAYOUT } from '/@/router/constant';
import { t } from '/@/hooks/web/useI18n';

/**
 * 'sample': '进口发运',
 */
const route: AppRouteModule = {
  path: '/import-ship',
  name: 'ImportShip',
  component: LAYOUT,
  redirect: '/import-ship/container-info',
  meta: {
    icon: 'tabler:package-import',
    title: t('routes.import-ship.main'),
    orderNo: 11001,
    roles: [20222078],
  },
  children: [
    /**
     * 'container-info: '集装箱信息维护',
     */
    {
      path: 'container-info',
      name: 'ImportShipContainerInfo',
      component: () => import('/@/views/import-ship/container-info/index.vue'),
      meta: {
        title: t('routes.import-ship.container-info'),
        roles: [20222079],
      },
    },
    /**
     * 'extra-charge': '额外费用维护',
     */
    {
      path: 'extra-charge',
      name: 'ImportShipExtraCharge',
      component: () => import('/@/views/import-ship/extra-charge/index.vue'),
      meta: {
        title: t('routes.import-ship.extra-charge'),
        roles: [20222080],
      },
    },
    /**
     * 'srm-ship-confirm: 'SRM-发运确认',
     */
    {
      path: 'srm-ship-confirm',
      name: 'ImportShipSrmShipConfirm',
      component: () => import('/@/views/import-ship/srm-ship-confirm/index.vue'),
      meta: {
        title: t('routes.import-ship.srm-ship-confirm'),
        roles: [20222081],
      },
    },
  ],
};

export default route;
